import { Navigate } from "react-router-dom";

export default function AdminRoute({ children, allowBilling = false }) {
    const isAdmin = localStorage.getItem("isAdmin") === "true";
    const canBilling = localStorage.getItem("canBilling") === "true";
    const hasAccess = isAdmin || (allowBilling && canBilling);

    return hasAccess ? children : <Navigate to="/login" />;
}
